import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'
import {orderDetailSn} from '@/api/server/order'
import {warning, success} from '@/utils/message'
import VueQr from 'vue-qr';

export default {
  name: 'PayLinePage',
  mixins: [commonMixin],
  data () {
    return {
      _orderSn: null,
      qrcode: null,
      orderInfo: null,
      timer: null,
      payStatus: false
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    VueQr
  },
  methods: {
    onMyOrder () {
      this.$router.push({name: 'user-order'})
    },
    getOrder () {
      let query = {
        order_sn: this._orderSn
      }
      orderDetailSn(query).then( (res) => {
        if (res.code === 200 && res.data) {
          this.orderInfo = res.data
        } else {
          warning(res.message)
          this.$router.push({name: 'user-order'});
        }
      })
    },
    reset () {
      this.qrcode = null
      this.orderInfo = null
      this.payStatus = false
      this.getOrder()
    },
    handleRoute (route) {
        if (route.name === 'payline') {
          this._orderSn = this.$route.query.order_sn
          this.reset()
        }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  },
  created() {
  }
}